import {
  REQUESTING_REFERRING_PROVIDERS,
  RECEIVE_REFERRING_PROVIDERS,
} from 'agent_portal/actions/ReferringProvidersActions';

const initialState = {
  isFetching: false,
  items: [],
  lastUpdated: null,
};

export default function referringProviders(state = initialState, action) {
  switch (action.type) {
    case REQUESTING_REFERRING_PROVIDERS:
      return Object.assign({}, state, {
        isFetching: true,
      });

    case RECEIVE_REFERRING_PROVIDERS:
      return Object.assign({}, state, {
        isFetching: false,
        items: action.referringProviders,
        lastUpdated: action.receivedAt,
      });

    default:
      return state;
  }
}
